import * as React from "react";
import DashboardOtifDetalhe from "./detalhe";
import DashboardOtifTopo from "./topo";

export const DashboardOtifPage = () => {
  return (
    <React.Fragment>
      <DashboardOtifTopo />
      <DashboardOtifDetalhe />
    </React.Fragment>
  );
};